<style src="vue-select/dist/vue-select.css"></style>
<style>
    .table-sm {
        font-size: 14px;
    }
</style>

<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Jurnal Umum</h3>
                            <div class="card-tools">
                                <button type="button" class="btn btn-sm btn-primary" @click="newModal">
									<i class="fa fa-plus-square"></i>
									Tambah
								</button>
                            </div>
                        </div>
                        <v-app>
                            <v-main>
                                <div class="card-body table-responsive p-2">
                                    <table class="table table-hover table-sm">
                                        <thead>
                                            <tr>
                                                <th>NO</th>
                                                <th>TANGGAL</th>
                                                <th>NO BUKTI</th>
                                                <th>KETERANGAN</th>
                                                <th>NAMA AKUN</th>
                                                <th>NAMA AKUN BANTU</th>
                                                <th>DEBET</th>
                                                <th>KREDIT</th>
                                                <!-- <th>AKSI</th> -->
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(row, index) in dataset.data" :key="row.id">
                                                <td>{{index+1}}</td>
                                                <td>{{ row.tanggal }}</td>
                                                <td>{{ row.no_bukti }}</td>
                                                <td>{{ row.keterangan }}</td>
                                                <td>{{ row.nama_akun }}</td>
                                                <td>{{ row.nama_bantu }}</td>
                                                <td>{{ row.debet }}</td>
                                                <td>{{ row.kredit }}</td>
                                                <!-- <td>
                                                    <button @click="editModal(row)" class="btn btn-sm btn-primary">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                    <button @click="deleteData(row.id)" class="btn btn-sm btn-danger">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </td> -->
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
        
                                <div class="card-footer">
                                    <pagination :data="dataset" @pagination-change-page="getResults"></pagination>
                                </div>
                            </v-main>
                        </v-app>

                    </div>
                </div>
            </div>

            <!-- Modal -->
			<div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" v-show="!editmode">Input Jurnal</h5>
							<h5 class="modal-title" v-show="editmode">Edit Juranl</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>

						<form @submit.prevent="editmode ? updateData() : createData()">
							<div class="modal-body">
                                <div class="form-group">
                                    <label>Tanggal</label>
                                    <v-dialog
                                        ref="dialogs"
                                        v-model="inv_modal_tanggal"
                                        persistent
                                        width="290px"
                                        :retain-focus="false"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <div class="input-group">
                                                <div class="input-group-append">
                                                    <span class="input-group-text">
                                                        <v-icon>mdi-calendar</v-icon>
                                                    </span>
                                                </div>
                                                <input 
                                                    v-model="tanggal"
                                                    type="text"
                                                    class="form-control"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </div>
                                        </template>
                                        <v-date-picker
                                            v-model="tanggal"
                                            type="date"
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="inv_modal_tanggal = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="saveTanggal">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </div>

                                <div class="form-group">
									<label>No Bukti</label>
									<input v-model="form.no_bukti" type="text" name="no_bukti" class="form-control"
										:class="{ 'is-invalid': form.errors.has('no_bukti') }" required>
									<has-error :form="form" field="no_bukti"></has-error>
								</div>

                                <div class="form-group">
                                    <label>Keterangan</label>
                                    <textarea 
                                        v-model="form.keterangan" 
                                        name="keterangan" 
                                        class="form-control"
                                        rows="3"
                                        :class="{ 'is-invalid': form.errors.has('keterangan') }"
                                        required
                                    ></textarea>
                                    <has-error :form="form" field="keterangan"></has-error>
                                </div>
                                <div class="form-group">
                                    <label>Daftar Items</label>
                                    <table class="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th style="width: 50%;">AKUN</th>
                                                <th style="width: 20%;">DEBET</th>
                                                <th style="width: 20%;">KREDIT</th>
                                                <th style="width: 10%;">AKSI</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in form.items" :key="item.id">
                                                <td>
                                                    <select 
                                                        :id="'kode_akun_' + item.id"
                                                        class="form-control" 
                                                        v-model="item.kode_akun"
                                                        :class="{ 'is-invalid': adaeror['kode_akun'] }"
                                                        required
                                                    >
                                                        <option value="" disabled selected>Pilih...</option>
                                                        <optgroup 
                                                            v-for="(item, index) in kode_akun"
                                                            :key="item.parent.kode_akun"
                                                            :label="item.parent.nama_akun"
                                                        >
                                                            <option 
                                                                v-for="(child, childIndex) in item.children"
                                                                :key="child.kode_akun"
                                                                :value="child.kode_akun"
                                                            >
                                                                {{ child.nama_akun }}
                                                            </option>
                                                        </optgroup>
                                                    </select>

                                                    <small v-if="adaeror['kode_akun']" class="text-danger">
                                                        {{ adaeror["kode_akun"].join(', ') }}
                                                    </small>
                                                </td>
                                                <td>
                                                    <input type="number" class="form-control" v-model="item.debet" name="debet[]" step="0.01" />
                                                </td>
                                                <td>
                                                    <input type="number" class="form-control" v-model="item.kredit" name="kredit[]" step="0.01" />
                                                </td>
                                                <td style="text-align: center;">
                                                    <a href="#" @click.prevent="hapusRow(item.id)" class="btn btn-sm btn-danger" title="">
                                                        <i class="fas fa-trash" aria-hidden="true"></i>
                                                    </a>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <a href="#" @click.prevent="addRow()" class="btn btn-sm btn-info" title="Tambah Barang">
                                        <i class="fas fa-plus" aria-hidden="true"></i> Tambah Baris
                                    </a>
                                </div>
							</div>
							<div class="modal-footer">
								<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
								<button v-show="editmode" type="submit" class="btn btn-success">Edit!</button>
								<button v-show="!editmode" type="submit" class="btn btn-primary">Tambah!</button>
							</div>
						</form>
					</div>
				</div>
			</div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                editmode: false,
                parents: {},
                adaeror: [],
                inv_modal_tanggal: false,
                tanggal: new Date().toISOString().substr(0, 10),
                kode_akun: [],
                headers: [],
                dataset: {},
                form: new Form({
                    tanggal: '',
                    no_bukti: '',
                    keterangan: '',
                    kode_akun: '',
                    items: [],
                })
            };
        },

        computed: {
            formattedPostSaldo() {
                return (value) => {
                    if (value === 1) return 'Debet';
                    if (value === 2) return 'Credit';
                    return '-';
                };
            },

            displayTanggal() {
                return this.form.tanggal ? this.formatDate(this.form.tanggal) : "";
            },

            groupedKodeAkun() {
                let groups = [];
                // Ambil data parent
                let parentGroups = this.kodeAkun.filter(item => item.id_parent === null);
                
                // Iterasi parent dan ambil children-nya
                parentGroups.forEach(parent => {
                    let children = this.kodeAkun.filter(item => item.id_parent === parent.kode_akun);
                    groups.push({
                    parent, 
                    children
                    });
                });
                
                return groups;
            }
        },

        methods: {

            async getResults(page = 1) {
				try {
					this.$Progress.start();
					const { data } = await axios.get(`api/jurnal?page=${page}`);
					this.dataset = data.data;
					this.$Progress.finish();
				} catch (error) {
					console.error("Error fetching data:", error);
					this.$Progress.fail();
				}
			},

            saveTanggal() {
                this.form.tanggal = this.tanggal; 
                this.inv_modal_tanggal = false;
            },

            
            editModal(rowEdit) {
                this.editmode = true;
                this.form.reset();
                this.form.fill(rowEdit);

                $('#addNew').modal('show');
            },

            newModal() {
                this.editmode = false;
                this.form.reset();
                $('#addNew').modal('show');
            },

            fetchKodeAkun() {
                axios.get('api/jurnal/list_kode_akun').then(response => {
                    this.kode_akun = response.data.data;
                }).catch(error => {
                    console.error("Error fetching data:", error);
                });
            },

            addRow() {
                const uniqueId = Date.now();
                this.form.items.push({ id: uniqueId, kode_akun: '', debet: '', kredit: '' });
            },


            hapusRow(id) {
                const index = this.form.items.findIndex(item => item.id === id);
                if (index !== -1) {
                    const select = document.querySelector(`#kode_akun_${id}`);
                    if (select && $(select).hasClass("select2-hidden-accessible")) {
                        $(select).select2('destroy');
                    }
                    
                    this.form.items.splice(index, 1);
                }
            },


            // Fungsi untuk mendapatkan child berdasarkan kode_akun (id_parent)
            childAkun(parentKode) {
                return this.kode_akun.filter(akun => akun.id_parent === parentKode);
            },

            async createData() {
                try {
                    this.$Progress.start();

                    this.form.tanggal = this.tanggal;

                    // const data = {
                    //     no_bukti: this.form.no_bukti,
                    //     keterangan: this.form.keterangan,
                    //     tanggal: this.form.tanggal,
                    //     items: this.form.items
                    // };

                    // console.log(data);

                    const formData = {
                        no_bukti: this.form.no_bukti,
                        keterangan: this.form.keterangan,
                        tanggal: this.form.tanggal,
                        items: this.form.items.map(item => ({
                            kode_akun: item.kode_akun,
                            debet: parseFloat(item.debet) || 0,
                            kredit: parseFloat(item.kredit) || 0
                        }))
                    };


                    const response = await this.form.post('api/jurnal', formData);

                    console.log(response);

                    if (response.data.success) {
                        $('#addNew').modal('hide');
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });

                        this.$Progress.finish();
                        this.getResults(); 
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occurred! Please try again'
                        });

                        this.$Progress.fail();
                    }
                } catch (error) {
                    Toast.fire({
                        icon: 'error',
                        title: error.response?.data?.message || 'Terjadi kesalahan, silakan coba lagi'
                    });

                    this.$Progress.fail();
                }
            },

            async updateData() {
                this.$Progress.start();
                try {
                    const response = await this.form.put(`api/bantu/${this.form.id}`);

                    // Sembunyikan modal secara Vue-friendly (gunakan ref jika memungkinkan)
                    $('#addNew').modal('hide');

                    // Tampilkan notifikasi sukses
                    Toast.fire({
                        icon: 'success',
                        title: response.data.message
                    });

                    this.$Progress.finish();

                    // Refresh data setelah update
                    this.getResults();
                } catch (error) {
                    this.$Progress.fail();
                    Toast.fire({
                        icon: 'error',
                        title: 'Terjadi kesalahan saat update data.'
                    });
                }
            },

            async deleteData(id) {
                try {
                    const result = await Swal.fire({
                        title: 'Hapus?',
                        text: "Yakin untuk Menghapus Kode Akun?",
                        showCancelButton: true,
                        confirmButtonColor: '#d33',
                        cancelButtonColor: '#3085d6',
                        confirmButtonText: 'Ya, Hapus!'
                    });

                    // Jika user menekan tombol "Ya, Hapus!"
                    if (result.isConfirmed) {
                        await this.form.delete(`api/bantu/${id}`);

                        Swal.fire(
                            'Terhapus!',
                            'Data Kode Akun berhasil dihapus.',
                            'success'
                        );

                        // Refresh data setelah menghapus
                        this.getResults();
                    }
                } catch (error) {
                    Swal.fire("Hapus Gagal!", "Terjadi kesalahan saat menghapus data.", "warning");
                }
            },

        },

        mounted() {
            this.getResults();
            this.fetchKodeAkun();
        },

        created() {
            this.$Progress.start();
            this.getResults();
            this.fetchKodeAkun();
            this.$Progress.finish();
        },
    }
</script>